import arrowBack from "../../assets/img/Vector.svg";
import React, { useEffect, useState, useRef } from "react";
import { Box, Button, Typography, Grid } from "@mui/material";
import NewAppBar from "components/Navbars/AppBar";
import Footer from "views/Landing/Footer";
// import JobCard from "components/JobCard";
// import ApplicationForm from "components/ApplicationForm";
import useUserId from "hooks/useUserId";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useSnackbar } from "hooks/useSbackbar";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ApplicationForm from "./ApplicationForm";
import JobCard from "./JobCard";
import EmptyJobState from "./EmptyJobState ";
import JobDetailPage from "./EmptyJobState ";
import { LoadingDots } from "components/Loading/LoadingDots";
import { ModernLoader } from "components/Loading/LoadingDots";
import { debugAccessToken, checkTokenValidity } from "utils/debugUserId";
import QuizDialog from "./QuizDialog";
import { trackCandidateApplication, trackFileImport } from 'utils/analytics';

const JobApplicationPage = ({
  setHiddforum = () => { },
  post_id,
  // post_title,
  // postApplied,
  // setIsClicked,
  //   hasApplied,
  //   setHasApplied,
  onError = (err) => console.error("Unhandled error:", err),
  // job
  // handlePostuler,
}) => {
  const state = useLocation().state;

  const [formData, setFormData] = useState({
    academicDegree: "",
    lastPostOccupied: "",
    linkedinProfile: "",
    dateOfBirth: null,
    familyStatus: "",
    fieldOfStudy: "",
    resumeUploaded: false,
    coverLetterUploaded: false,
  });
  const [formErrors, setFormErrors] = useState({});
  const [uploadedFilesList, setUploadedFilesList] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFilename, setSelectedFilename] = useState(null);
  const location = useLocation();
  const { job, cameFromLogin } = location.state || {};
  const { t } = useTranslation();
  const userid = useUserId();
  const userId = userid.userId;
  const apiUrl = process.env.REACT_APP_API_URL;
  const { showSnackbar } = useSnackbar();
  const [uploadedFiles, setUploadedFiles] = useState({ resumes: null });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadedResume, setUploadedResume] = useState();
  const [resumeUploaded, setResumeUploaded] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const [hasAppliedToThisPost, setHasAppliedToThisPost] = useState(true);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [applied, setApplied] = useState(true);
  const [isLoadingUserData, setIsLoadingUserData] = useState(true);
  const [coverLetterText, setCoverLetterText] = useState("");
  const [useMatchingProfile, setUseMatchingProfile] = useState(false);
  const handleCoverLetterChange = (e) => {
    setCoverLetterText(e.target.value);
  };

  // Quiz dialog state
  const [quizDialogOpen, setQuizDialogOpen] = useState(false);
  const [quizAnswers, setQuizAnswers] = useState(null);
  const quizAnswersRef = useRef(null);
  const [pendingSubmitData, setPendingSubmitData] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    console.log("state:", state);
  }, []);

  useEffect(() => {
    console.log("job:==", job);
  }, [job]);

  // Debug userid changes
  useEffect(() => {
    console.log('UserID state changed:', {
      userId: userid.userId,
      role: userid.role,
      hasToken: !!localStorage.getItem('accessToken')
    });

    // Debug token validity
    const tokenCheck = checkTokenValidity();
    console.log('Token validity check:', tokenCheck);

    if (!tokenCheck.valid) {
      console.error('Token issue detected:', tokenCheck.reason);
    }
  }, [userid.userId, userid.role]);

  // Manage loading state based on userId availability
  useEffect(() => {
    const hasToken = !!localStorage.getItem('accessToken');
    if (hasToken && userid.userId) {
      setIsLoadingUserData(false);
    } else if (hasToken && !userid.userId) {
      // We have a token but no userId yet, keep loading
      setIsLoadingUserData(true);
    } else {
      // No token, redirect to login or handle appropriately
      setIsLoadingUserData(false);
    }
  }, [userid.userId]);

  useEffect(() => {
    console.log('user infos is :', userid);
    // Only fetch candidate info when we have userId and user is not a recruiter
    if (userid.role !== "r" && userId) {
      fetchCandidateInfo();
    }
  }, [userid.role, userId]); // Dependencies: wait for both role and userId

  const handlePostuler = async () => {
    const candidateId = userId;
    console.log('Data we are sending: ', candidateId, '---', job.id);

    // Check if already applied before submitting
    if (applied || hasAppliedToThisPost) {
      console.log('Already applied to this post, skipping submission');
      showSnackbar(t("applicationForm.alreadyApplied"), {
        severity: "warning",
        position: "bottom-left",
        duration: 3000,
      });
      return false; // Return false to indicate no new application was made
    }

    const endpoint = `${apiUrl}candidates/application/create-matching-profile/`;
    const body = {
      candidate: candidateId,
      post: [job.id],
      quiz: quizAnswersRef.current?.answers || quizAnswers?.answers,
    };

    try {
      console.log('Data we are sending: 2 ', candidateId, '---', job.id);
      console.log('[handlePostuler] Setting isSubmitting to true');
      setIsSubmitting(true);

      console.log('[handlePostuler] Making POST request to:', endpoint);
      console.log('[handlePostuler] Request body:', body);

      const response = await axios.post(endpoint, body, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 30000, // 30 second timeout
      });

      console.log('[handlePostuler] Response received:', response);
      console.log('[handlePostuler] Response status:', response.status);
      console.log('[handlePostuler] Response data:', response.data);
      console.log("🔥 BACKEND STATUS:", response.status);
      if (response.status === 200 || response.status === 201) {
        console.log('Data we are sending: 3 ', candidateId, '---', job.id);
        console.log('[handlePostuler] Application successful, showing success snackbar');
        showSnackbar(t("applicationForm.applicationSubmitted"), {
          severity: "success",
          position: "bottom-left",
          duration: 3000,
        });
        setApplied(true);
        setHasAppliedToThisPost(true);
        // Refresh the applied status
        await postApplied();
        console.log('[handlePostuler] Returning true');
        return true; // Return true to indicate success
      }
      console.log('[handlePostuler] Response status not 200/201, returning false');
      return false;
    } catch (error) {
      console.error('[handlePostuler] Error caught:', error);
      console.error('[handlePostuler] Error message:', error.message);
      console.error('[handlePostuler] Error response:', error.response);
      console.error('[handlePostuler] Error response data:', error.response?.data);
      console.error('[handlePostuler] Error response status:', error.response?.status);

      // Show appropriate error message
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.data?.detail || error.message || 'An error occurred';
      showSnackbar(errorMessage, {
        severity: "error",
        position: "bottom-left",
        duration: 3000,
      });
      return false; // Return false to indicate failure
    } finally {
      console.log('[handlePostuler] Setting isSubmitting to false in finally block');
      setIsSubmitting(false);

    }
  };

  const postApplied = async () => {
    // Don't make the call if we don't have a userId yet
    if (!userid.userId || !job?.id) {
      console.log('Waiting for userId or job data...', { userId: userid.userId, jobId: job?.id });
      return;
    }

    console.log('Checking if candidate applied...');
    try {
      const response = await fetch(
        `${apiUrl}candidates/is_applied_to_post/${userid.userId}/${job.id}/`, // ✅ trailing slash is important
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        if (response.status === 404) {
          console.error("Candidate or post not found");
          return { error: "Candidate or post not found" };
        } else {
          throw new Error(`An error occurred: ${response.statusText}`);
        }
      }

      const json = await response.json();
      console.log("applied?", json.is_applied);
      setApplied(json.is_applied);
      setIsClicked(false);
      return json;
    } catch (error) {
      console.error("Error loading data", error);
      return { error: error.message };
    }
  };


  useEffect(() => {
    // Only call postApplied when we have both userId and job data
    if (userid.userId && job?.id) {
      postApplied();
    }
  }, [userid.userId, job?.id]); // Dependencies: wait for both userId and job

  useEffect(() => {
    // Only call hasAlreadyApplied when we have userId and user is a candidate
    if (userid.role === "c" && userId) {
      hasAlreadyApplied();
    }
  }, [userid.role, userId]); // Dependencies: wait for both role and userId
  useEffect(() => {
    console.log("hasApplied:", hasApplied);

  }, [hasApplied])
  const hasAlreadyApplied = async () => {
    // Don't make the call if we don't have a userId yet
    if (!userId) {
      console.log('Waiting for userId before checking applications...');
      return;
    }

    try {
      const response = await axios.get(
        `${apiUrl}candidates/check-applied/${userId}/`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("response:", response.data);
      setHasApplied(response.data.has_applied);
    } catch (error) {
      console.error("Error :", error.response?.data || error.message);
    }
  };

  const navigate = useNavigate();
  const navigateBack = () => {
    // Get the state from location
    const { cameFromLogin } = location.state || {};

    // If we came from login, go to landing
    if (cameFromLogin) {
      navigate("/landing");
      return;
    }

    // Otherwise try to go back
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate("/landing");
    }
  };
  const updateCandidateInfo = async (formData) => {
    try {
      const response = await axios.patch(
        `${apiUrl}candidates/${userId}/update/`,
        {
          // Convert FormData to match the API's expected format
          academic_degree: formData.get("academicDegree") || null,
          last_post_occupied: formData.get("lastPostOccupied") || null,
          linkedin_profile: formData.get("linkedinProfile") || null,
          date_of_birth: formData.get("dateOfBirth")
            ? new Date(formData.get("dateOfBirth")).toISOString().split("T")[0]
            : null,
          family_status: formData.get("familyStatus") || null,
          field_of_study: formData.get("fieldOfStudy") || null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      console.log("User updated:", response.data);
      return response;
    } catch (error) {
      console.error("Error updating profile:", error);
      throw error;
    }
  };
  const handleFileSelect = (fileKey, file) => {
    console.log("Selecting file:", fileKey, file);

    if (!fileKey) {
      // Unchecking
      setSelectedFile(null);
      setResumeUploaded(false);
      setUploadedResume(null);
      setFormData((prev) => ({
        ...prev,
        resumeUploaded: false,
        selectedFileName: null,
      }));
      return;
    }

    // Selecting new file
    setSelectedFile(fileKey);
    setResumeUploaded(true);
    setUploadedResume(file);

    // Get the file name in the original format
    let fileName;
    if (file.resume) {
      fileName = file.resume.split("/").pop();
    } else if (file.name) {
      fileName = file.name;
    } else if (file.path) {
      fileName = file.path.split("/").pop();
    } else if (typeof file === "string") {
      fileName = file.split("/").pop();
    }

    console.log("Selected file name:", fileName);
    setSelectedFilename(fileName);
    setFormData((prev) => ({
      ...prev,
      resumeUploaded: true,
      selectedFileName: fileName,
    }));
  };

  const handleFileUpload = (event, fileType) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Track file upload
      trackFileImport(fileType, file.name, file.size);

      // Uncheck any previously selected file
      setSelectedFile(null);
      setUploadedResume(file);
      setResumeUploaded(true);

      if (fileType === "resume") {
        setFormData((prev) => ({
          ...prev,
          resumeUploaded: true,
          selectedFileName: file.name,
        }));
        setSelectedFilename(file.name);
        console.log("New resume uploaded:", file.name);
      } else {
        setFormData((prev) => ({
          ...prev,
          coverLetterUploaded: true,
        }));
      }

      setUploadedFilesList((prev) => ({
        ...prev,
        [fileType]: file,
      }));

      // Reset the file input
      event.target.value = "";
    }
  };

  const handleFileDelete = (key) => {
    setUploadedFilesList((prev) => {
      const newFiles = { ...prev };
      delete newFiles[key];
      return newFiles;
    });
    if (key === "resume") {
      setFormData((prev) => ({ ...prev, resumeUploaded: false }));
    } else {
      setFormData((prev) => ({ ...prev, coverLetterUploaded: false }));
    }
  };

  const handleShowFile = async (key, file) => {
    let fileURL;
    let resume_path;

    if (typeof file === "string") {
      resume_path = file;
    } else if (file && typeof file === "object") {
      resume_path = file.resume || file.path || file.name;
    } else {
      console.error("Invalid file type", file);
      return;
    }

    if (!resume_path) {
      console.log("Resume path is not available");
      return;
    }

    const normalizedResumePath = resume_path.replace(/\\/g, "/");
    fileURL = `${apiUrl}media/${normalizedResumePath}`;

    try {
      const response = await fetch(`${apiUrl}ai/search_resume/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ resume_url: fileURL }),
      });

      const contentType = response.headers.get("content-type");

      if (response.ok) {
        if (contentType && contentType.includes("application/pdf")) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        } else {
          console.log("Unexpected response from server");
        }
      } else {
        if (contentType && contentType.includes("text/html")) {
          const htmlContent = await response.text();
          const newWindow = window.open();
          newWindow.document.write(htmlContent);
          newWindow.document.close();
        } else {
          const data = await response.json();
          console.log(data.message);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onSubmit = async (data) => {
    console.log("[1] Submitting application...");
    console.log("[2] Current resume state:", {
      uploadedResume,
      selectedFile,
      resumeUploaded,
      formDataResumeUploaded: formData.resumeUploaded,
      uploadedFilesList,
      selectedFilename,
      uploadedFiles,
    });

    // Ensure resume state is synchronized
    if (formData.resumeUploaded && !resumeUploaded) {
      setResumeUploaded(true);
    }

    // if (!validateForm()) {
    //   console.log("[2] Form validation failed.");
    //   return;
    // }

    // Only set isSubmitting for regular applications
    // Smart profile applications manage their own isSubmitting state in handlePostuler()
    if (!useMatchingProfile) {
      setIsSubmitting(true);
    }
    try {
      console.log("[3] Form validation passed. Preparing FormData...");

      const applicationFormData = new FormData();

      if (isNaN(state.job.id)) {
        throw new Error("Invalid post ID: must be a number");
      }

      applicationFormData.append("post", state.job.id);
      applicationFormData.append("candidate", userId);
      applicationFormData.append("status", "Application");

      console.log("[4] Post ID:", state.job.id, "type:", typeof state.job.id);

      // Update candidate profile
      // try {
      //   console.log("[5] Updating candidate info...");
      //   const candidateFormData = new FormData();
      //   // ... existing candidate form data code ...
      //   await updateCandidateInfo(candidateFormData);
      //   console.log("[6] Candidate profile updated successfully.");
      // } catch (error) {
      //   console.log("[7] Error updating profile:", error);
      // }

      // Enhanced resume handling
      let resumeHandled = false;
      console.log("[8] Starting resume handling...");

      // 1. Check for newly uploaded resume
      if (uploadedResume) {
        console.log("[9] Processing uploadedResume:", uploadedResume);
        if (typeof uploadedResume === "string") {
          const relativePath = uploadedResume.split("media/").pop();
          applicationFormData.append("resume_path", relativePath);
          resumeHandled = true;
          console.log("[9.1] Added resume path from string:", relativePath);
        } else if (uploadedResume instanceof File) {
          applicationFormData.append("resume", uploadedResume);
          applicationFormData.append(
            "resume_path",
            `resumes/post_${state.job.id}/${standardizeFilename(
              uploadedResume.name
            )}`
          );
          resumeHandled = true;
          console.log("[9.2] Added resume file:", uploadedResume.name);
        }
      }

      // 2. Check for selected file from list
      if (!resumeHandled && selectedFile && uploadedFilesList[selectedFile]) {
        console.log("[10] Processing selected file:", selectedFile);
        const file = uploadedFilesList[selectedFile];
        if (file.resume) {
          const relativePath = file.resume.split("media/").pop();
          applicationFormData.append("resume_path", relativePath);
          resumeHandled = true;
          console.log(
            "[10.1] Added resume path from selected file:",
            relativePath
          );
        }
      }

      // 3. Check for file from form data
      if (!resumeHandled && data.resume && data.resume[0]) {
        console.log("[11] Processing form data resume");
        applicationFormData.append("resume", data.resume[0]);
        applicationFormData.append(
          "resume_path",
          `resumes/post_${state.job.id}/${standardizeFilename(
            data.resume[0].name
          )}`
        );
        resumeHandled = true;
        console.log("[11.1] Added resume from form data:", data.resume[0].name);
      }

      // 4. Check for resume in uploadedFiles
      if (!resumeHandled && uploadedFiles.resumes) {
        console.log("[12] Processing resume from uploadedFiles");
        if (typeof uploadedFiles.resumes === "string") {
          const relativePath = uploadedFiles.resumes.split("media/").pop();
          applicationFormData.append("resume_path", relativePath);
          resumeHandled = true;
          console.log(
            "[12.1] Added resume path from uploadedFiles:",
            relativePath
          );
        }
      }

      // if (!resumeHandled) {
      //   console.log("[13] No resume found in any source. Current state:", {
      //     uploadedResume,
      //     selectedFile,
      //     resumeUploaded,
      //     formDataResumeUploaded: formData.resumeUploaded,
      //     uploadedFilesList,
      //     uploadedFiles,
      //     selectedFilename,
      //   });
      //   throw new Error(t("applicationForm.noResumeSelected"));
      // }
      if (!resumeHandled && !useMatchingProfile) {
        console.log("[9] No resume found in any source. Current state:", {
          uploadedResume,
          selectedFile,
          resumeUploaded,
          uploadedFilesList,
          formData: data
        });
        throw new Error(t("applicationForm.noResumeSelected"));
      }

      console.log("[14] Resume handled successfully");

      // Handle cover letter
      if (data.cover_letter && data.cover_letter[0]) {
        applicationFormData.append("cover_letter", data.cover_letter[0]);
        console.log("[15] Cover letter added:", data.cover_letter[0].name);
      }

      // Handle quiz answers
      const currentQuizAnswers = quizAnswersRef.current || quizAnswers;
      if (currentQuizAnswers && currentQuizAnswers.answers) {
        applicationFormData.append("quiz", JSON.stringify(currentQuizAnswers.answers));
        console.log("[15.5] Quiz answers added:", currentQuizAnswers.answers);
      }

      // Log all form data being sent
      console.log("[16] Final form data being submitted:");
      for (let [key, value] of applicationFormData.entries()) {
        console.log(`${key}: ${value instanceof File ? value.name : value}`);
      }

      // Submit application
      console.log("[17] Submitting application to backend...", useMatchingProfile);
      if (useMatchingProfile) {
        console.log("[17.5] Smart profile application submitted successfully.");
        // Use smart profile application (no resume needed)
        const success = await handlePostuler();
        // handlePostuler manages its own isSubmitting state and shows snackbar
        // Only update UI if application was successful
        if (success) {
          console.log("[18] Smart profile application submitted successfully.");
          setIsClicked(true);
          if (typeof setHiddforum === "function") {
            setHiddforum(true);
          }
          reset();
          setResetTrigger((prev) => !prev);
          console.log("[19] Form reset, UI updated.");
        }
      }
      else {
        // Regular application with resume
        await submitApplication(applicationFormData);
        console.log("[18] Application submitted successfully.");
        // Update UI state
        setIsClicked(true);
        if (typeof setHiddforum === "function") {
          setHiddforum(true);
        }
        setHasAppliedToThisPost(true);
        reset();
        // Trigger reset in child component
        setResetTrigger((prev) => !prev);
        console.log("[19] Form reset, UI updated.");
      }
    } catch (error) {
      console.log("[20] Caught error:", error);
      console.error(
        t("applicationForm.errorSubmittingApplication"),
        error.response?.data || error.message
      );

      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          error.response?.data?.detail || 
                          (error.response?.data ? JSON.stringify(error.response.data) : error.message);

      showSnackbar(errorMessage, {
          severity: "error",
          position: "bottom-left",
          duration: 5000,
      });
    } finally {
      // Reset isSubmitting for regular applications
      // Smart profile applications manage their own isSubmitting state in handlePostuler()
      if (!useMatchingProfile) {
        setIsSubmitting(false);
      }
      console.log("[21] Submission complete.");
    }
  };

  // Fixed submitApplication function with better error handling
  const submitApplication = async (formData) => {
    try {
      const response = await axios.post(
        `${apiUrl}candidates/application/create/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Application submitted:", response.data);
      
      // Track successful application
      trackCandidateApplication(
        job?.id || 'unknown',
        job?.title || 'Unknown Position',
        'standard'
      );
      
      showSnackbar(t("applicationForm.applicationSubmitted"), {
        severity: "success",
        position: "bottom-left",
        duration: 3000,
      });
      return response;
    } catch (error) {
      console.error(
        "Application submission error:",
        error.response?.data || error.message
      );
      throw error; // Re-throw to be handled by caller
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!hasApplied) {
      if (!formData.academicDegree) {
        console.log("Missing academicDegree");
        errors.academicDegree = t("applicationForm.errors.academicDegree");
      }
      if (!formData.fieldOfStudy) {
        console.log("Missing fieldOfStudy");
        errors.fieldOfStudy = t("applicationForm.errors.fieldOfStudy");
      }
      if (!formData.lastPostOccupied) {
        console.log("Missing lastPostOccupied");
        errors.lastPostOccupied = t("applicationForm.errors.lastPostOccupied");
      }
      if (!formData.dateOfBirth) {
        console.log("Missing dateOfBirth");
        errors.dateOfBirth = t("applicationForm.errors.dateOfBirth");
      }

      // Check for resume in all possible locations
      const hasResume =
        resumeUploaded ||
        formData.resumeUploaded ||
        uploadedResume ||
        selectedFile ||
        (uploadedFiles && uploadedFiles.resumes);

      if (!hasResume) {
        console.log("Missing resume - Current state:", {
          resumeUploaded,
          formDataResumeUploaded: formData.resumeUploaded,
          uploadedResume,
          selectedFile,
          uploadedFiles,
        });
        errors.resume = t("applicationForm.errors.resume");
      }
    }

    console.log("Form validation state:", {
      academicDegree: Boolean(formData.academicDegree),
      fieldOfStudy: Boolean(formData.fieldOfStudy),
      lastPostOccupied: Boolean(formData.lastPostOccupied),
      dateOfBirth: Boolean(formData.dateOfBirth),
      resumeUploaded,
      formDataResumeUploaded: formData.resumeUploaded,
      uploadedResume: Boolean(uploadedResume),
      selectedFile: Boolean(selectedFile),
      uploadedFiles: Boolean(uploadedFiles?.resumes),
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (job) {
      setHasAppliedToThisPost(job.has_applied);
    }
  }, [job]);
  useEffect(() => {
    console.log("Job data received:", job);

    if (!job) {
      console.log("No job data found in location state");
      // Try to get job from localStorage as fallback
      const storedJob = localStorage.getItem("job");
      if (storedJob) {
        try {
          const parsedJob = JSON.parse(storedJob);
          // Update the state with the job from localStorage
          location.state = { ...location.state, job: parsedJob };
          setHasAppliedToThisPost(parsedJob.has_applied);
        } catch (error) {
          console.error("Error parsing stored job data:", error);
        }
      }
    }
  }, [job, location]);

  const standardizeFilename = (filename) => {
    // Remove any leading/trailing spaces
    let cleanName = filename.trim();
    // Replace spaces with underscores
    cleanName = cleanName.replace(/\s+/g, "_");
    return cleanName;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleDateChange = (newValue) => {
    setFormData((prevData) => ({ ...prevData, dateOfBirth: newValue }));
    if (formErrors.dateOfBirth) {
      setFormErrors((prev) => ({ ...prev, dateOfBirth: null }));
    }
  };

  const fetchCandidateInfo = async () => {
    // Don't make the call if we don't have a userId yet
    if (!userId) {
      console.log('Waiting for userId before fetching candidate info...');
      return;
    }

    try {
      const response = await axios.get(`${apiUrl}candidates/${userId}/find/`);
      setFormData({
        academicDegree: response.data.academic_degree,
        lastPostOccupied: response.data.last_post_occupied,
        linkedinProfile: response.data.linkedin_profile,
        dateOfBirth: response.data.date_of_birth,
        familyStatus: response.data.family_status,
        fieldOfStudy: response.data.field_of_study,
      });
      return response;
    } catch (error) {
      console.error('Error fetching candidate info:', error);
      return null;
    }
  };

  useEffect(() => {
    console.log("uploaded files: ", uploadedFiles);
  }, []);

  useEffect(() => {
    // Only load files when we have userId
    if (userId) {
      loadFiles();
    }
  }, [userId]); // Dependency: wait for userId

  const loadFiles = async () => {
    // Don't make the call if we don't have a userId yet
    if (!userId) {
      console.log('Waiting for userId before loading files...');
      return;
    }

    try {
      const response = await fetch(
        `${apiUrl}authentication/files-for-candidate/${userId}/`
      );
      if (!response.ok) {
        throw new Error(`An error occurred: ${response.statusText}`);
      }
      const json = await response.json();
      setUploadedFiles(json);
      setUploadedFilesList(json);
    } catch (error) {
      console.error("Error loading files:", error);
    }
  };

  if (!job) {
    console.log("Rendering empty state - no job data available");
    return <JobDetailPage />;
  }

  // Show loading while waiting for user data
  if (isLoadingUserData) {
    return (
      <Box>
        <NewAppBar />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <ModernLoader size={48} />
          <Typography sx={{ fontFamily: 'Poppins', color: '#666' }}>
            Loading user information...
          </Typography>
        </Box>
      </Box>
    );
  }
  return (
    <Box>
      <NewAppBar />
      <Box
        sx={{
          mx: "auto",
          py: { xs: 4, md: 8 },
          px: { xs: 2, sm: 4, md: 7 },
          maxWidth: "1300px",
          width: "100%",
          margin: "0 auto",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={navigateBack}
          sx={{
            alignSelf: "flex-start",
            fontFamily: "Poppins",
            fontSize: "14px",
            textTransform: "none",
            mb: 4,
            padding: "14px 26px 14px 26px",
            borderRadius: "11px",
          }}
        >
          <img src={arrowBack} width={13} height={13} alt="Back arrow" />
          <Typography
            sx={{
              marginLeft: 1,
            }}
          >
            {t("applicationPage.jobDetails")}
          </Typography>
        </Button>

        <JobCard job={job} />

        <Typography
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: { xs: "24px", md: "32px" },
            lineHeight: "100%",
            letterSpacing: "0%",
            color: "#0017E7",
            marginBottom: 4,
          }}
        >
          {t("applicationPage.applyForOffer")}
        </Typography>

        <ApplicationForm
          formData={formData}
          setFormData={setFormData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          handleInputChange={handleInputChange}
          handleDateChange={handleDateChange}
          handleFileUpload={handleFileUpload}
          uploadedFilesList={uploadedFilesList}
          handleFileSelect={handleFileSelect}
          handleFileDelete={handleFileDelete}
          handleShowFile={handleShowFile}
          handleSubmit={handleSubmit(onSubmit)}
          hasApplied={hasApplied}
          register={register}
          selectedFile={selectedFile}
          selectedFilename={selectedFilename}
          isSubmitting={isSubmitting}
          resetTrigger={resetTrigger}
          job={job}
          coverLetterText={coverLetterText}
          onCoverLetterChange={handleCoverLetterChange}
          useMatchingProfile={useMatchingProfile}
          setUseMatchingProfile={setUseMatchingProfile}
          handlePostuler={handlePostuler}
        />
        {userid.role === "c" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-end" },
              marginTop: 4,
            }}
          >
            <Button
              variant="contained"
              disabled={isSubmitting || hasAppliedToThisPost || applied || (!resumeUploaded && !useMatchingProfile)}
              sx={{
                bgcolor: "#0017e7",
                color: "#fff",
                width: { xs: "100%", sm: "177px" },
                height: "50px",
                borderRadius: "11px",
                padding: "14px 16px",
                gap: "10px",
                textTransform: "none",
              }}
              type="button"
              onClick={async () => {
                // Check if quiz exists for this post before opening dialog
                try {
                  const response = await fetch(`${apiUrl}posts/post_quiz/${job?.id}/`);
                  const data = await response.json();

                  // -1 means no quiz, proceed directly with application
                  if (data === -1) {
                    console.log('No quiz for this post, proceeding with application');
                    handleSubmit(onSubmit)();
                  } else {
                    // Quiz exists, open the dialog
                    setQuizDialogOpen(true);
                  }
                } catch (error) {
                  console.error('Error checking quiz:', error);
                  // On error, proceed with application without quiz
                  handleSubmit(onSubmit)();
                }
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                }}
              >
                {applied ? (
                  t("applicationPage.alreadyApplied")
                ) : isSubmitting ? (
                  <Box
                    sx={{ display: "flex", flexDirection: "row", gap: "10px" }}
                  >
                    <ModernLoader size={24} />
                    {t("applicationPage.applyForOffer")}
                  </Box>
                ) : (
                  t("applicationPage.applyForOffer")
                )}
              </Typography>
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-end" },
              marginTop: 4,
            }}
          >
            <Button
              variant="contained"
              // onClick={handleSubmit(onSubmit)}
              disabled={true}
              sx={{
                bgcolor: "#0017e7",
                color: "#fff",
                width: { xs: "100%", sm: "177px" },
                height: "50px",
                borderRadius: "11px",
                padding: "14px 16px",
                gap: "10px",
                textTransform: "none",
              }}
              type="submit"
              form="application-form"
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                }}
              >
                {t("applicationPage.notAvailableForRecruiters")}
              </Typography>
            </Button>
          </Box>
        )}
      </Box>

      {/* Quiz Dialog */}
      <QuizDialog
        postId={job?.id}
        open={quizDialogOpen}
        onClose={() => setQuizDialogOpen(false)}
        onComplete={(quizResult) => {
          setQuizDialogOpen(false);
          setQuizAnswers(quizResult);
          quizAnswersRef.current = quizResult;
          console.log('Quiz completed, proceeding with application:', quizResult);
          // Proceed with application submission
          handleSubmit(onSubmit)();
        }}
      />
      <Footer />
    </Box>
  );
};

export default JobApplicationPage;
